import axios from '@/api/axios'

const createTrainerResult = (trainerResult) => {
  return axios.post('/trainerResult', trainerResult)
}

const getTrainersResult = () => {
  return axios.get('/trainerResult')
}

const getTrainerResult = (id) => {
  return axios.get(`/trainerResult/${id}`)
}

const updateTrainerResult = (id, trainerResultInput) => {
  return axios.put(`/trainerResult/${id}`, trainerResultInput)
}

const deleteTrainerResult = (id) => {
  return axios.delete(`/trainerResult/${id}`)
}

const getTrainersResultById = (params) => {
  return axios.get(`/trainerResult${params}`).then((res) => res.data)
}

const getRewardSearchList = (params) => {
  return axios.get(`/events/rewardSearchList${params}`).then((res) => res.data)
}

export default {
  createTrainerResult,
  getTrainersResult,
  getTrainerResult,
  updateTrainerResult,
  deleteTrainerResult,
  getTrainersResultById,
  getRewardSearchList,
}
